import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import VModal from "@/components/vModal.vue";
import { useStoreState } from "@/hooks/useStoreState";

type vUpsellModalProps = {
  showModal: boolean;
  message?: string;
  showTutorialButton?: boolean;
  openSubscriptionInNewTab?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vUpsellModal',
  props: {
    showModal: { type: Boolean, default: false },
    message: { default: "" },
    showTutorialButton: { type: Boolean, default: false },
    openSubscriptionInNewTab: { type: Boolean, default: false }
  },
  emits: ['close', 'openTutorial'],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean, message: string, showTutorialButton: boolean, openSubscriptionInNewTab: boolean };




const storeState = useStoreState();

const translationOrFallback = (key: string, fallback: string) => {
  const translation = storeState.value.LocalizationModule.translations.get(key);
  return translation === "---" ? fallback : translation;
};

const resolvedMessage = computed(() => (
  props.message || translationOrFallback("upsell_default_message", "This feature requires a paid subscription to use.")
));

return { __sfc: true,props, emit, storeState, translationOrFallback, resolvedMessage, VModal }
}

})